"use strict";
/**
 * Live scoring / challenges: CTP and longest putt use total feet as a decimal in persistence;
 * UI collects feet + inches and formats stored decimals for display.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.isFeetInchesNumberChallenge = isFeetInchesNumberChallenge;
exports.feetAndInchesToDecimalFeet = feetAndInchesToDecimalFeet;
exports.roundToDecimalPlaces = roundToDecimalPlaces;
exports.normalizeFeetAndInches = normalizeFeetAndInches;
exports.formatDecimalFeetAsFeetInches = formatDecimalFeetAsFeetInches;
function isFeetInchesNumberChallenge(challenge) {
    return (String(challenge?.inputType ?? '').toLowerCase() === 'number' &&
        String(challenge?.units ?? '').toLowerCase() === 'feet');
}
function feetAndInchesToDecimalFeet(feet, inches) {
    const f = Number.isFinite(feet) ? feet : 0;
    const i = Number.isFinite(inches) ? inches : 0;
    return f + i / 12;
}
function roundToDecimalPlaces(value, decimalPlaces) {
    const p = Math.max(0, Math.floor(Number(decimalPlaces)));
    if (!Number.isFinite(value))
        return 0;
    const factor = 10 ** p;
    return Math.round(value * factor) / factor;
}
/** Normalize so inches live in [0, 12). */
function normalizeFeetAndInches(feet, inches) {
    let f = Number.isFinite(feet) ? feet : 0;
    let inch = Number.isFinite(inches) ? inches : 0;
    if (inch >= 12 || inch <= -12) {
        const carry = Math.trunc(inch / 12);
        f += carry;
        inch -= carry * 12;
    }
    if (inch < 0) {
        const borrow = Math.ceil(-inch / 12);
        f -= borrow;
        inch += borrow * 12;
    }
    return { feet: f, inches: inch };
}
/**
 * Renders a stored decimal-feet value as feet and inches (e.g. 5.5 → 5' 6").
 */
function formatDecimalFeetAsFeetInches(decimalFeet) {
    if (!Number.isFinite(decimalFeet))
        return String(decimalFeet);
    if (decimalFeet < 0)
        return String(decimalFeet);
    const totalInches = Math.round(decimalFeet * 12);
    const ft = Math.floor(totalInches / 12);
    const inch = totalInches % 12;
    if (inch === 0)
        return `${ft}'`;
    return `${ft}' ${inch}"`;
}
